<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/logo.isogrow.black.rev1.png" alt="IsoGrow" height="100"
                 class="mr-0 lg:mr-6">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-sub-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-ellipsis-v text-2xl"></i>
                </a>
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
            <div id="navbar-sub-7"
                 class="hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                    <li>
                        <a @click="processEducation" v-ripple v-tooltip="'Education'"
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-book text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Education</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processConfiguration" v-ripple v-tooltip="'Configuration'"
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-cog text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Configuration</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processProfile" v-ripple v-tooltip="'Profile'"
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-id-card text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Profile</span>
                        </a>
                    </li>
                    <li>
                        <a v-ripple v-tooltip="'Notifications'"
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>
                            <span class="block lg:hidden font-medium">Notifications</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processLogout" v-tooltip="'Logout'" v-ripple
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-power-off text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Logout</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
        <div id="navbar-7"
             class="py-3 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 border-top-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverview" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Overview</span>
                    </a>
                </li>
                <li>
                    <a @click="processPortfolio" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Portfolio</span>
                    </a>
                </li>
                <li>
                    <a @click="processGoals" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Goals</span>
                    </a>
                </li>
                <li>
                    <a @click="processTasks" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Tasks</span>
                    </a>
                </li>
                <li>
                    <a @click="processDocuments" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Documents</span>
                    </a>
                </li>
                <li>
                    <a @click="processTools" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Tools and Calculators</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                // console.log("[MenuMain][mounted] System is active.");
                console.log("[MenuMain][mounted] Data = ", data);
            })
            .catch(e => {
                // console.log("[MenuMain][mounted] System is NOT active.");
                console.log("[MenuMain][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuMain][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        }
        // else {
        //     console.log("[MenuMain][mounted] User is defined. this.userStore.userId = ", this.userStore.userId);
        // }
    },
    data() {
        return {};
    },
    methods: {
        async processLogout() {
            try {
                const responseData = await AuthenticationService.signoutUser(this.userStore.username);
                console.log('[MenuSiModuleMain][processLogout] Response = ', responseData);
            } catch (error) {
                console.error('[MenuSiModuleMain][processLogout] Error during signout:', error);
            }

            this.userStore.$reset();
            this.userStore.clearUser;
            window.location.href = "/#/isogrowLogin";
            window.location.reload();
        },
        processProfile() {
            window.location.href = "/#/isogrowProfile";
        },
        processConfiguration() {
            window.location.href = "/#/isogrowConfiguration";
        },
        processEducation() {
            window.location.href = "/#/isogrowEducation";
        },
        processOverview() {
            window.location.href = "/#/isogrowOverview";
        },
        processPortfolio() {
            window.location.href = "/#/isogrowNetWorth";
        },
        processGoals() {
            window.location.href = "/#/isogrowGoals";
        },
        processTasks() {
            window.location.href = "/#/isogrowTasks";
        },
        processDocuments() {
            window.location.href = "/#/isogrowDocuments";
        },
        processTools() {
            window.location.href = "/#/isogrowTools";
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
